import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailBtn", "phoneBtn", "emailField", "phoneField"]

  connect() {
    this.showEmail()
  }

  showEmail() {
    this.emailFieldTarget.classList.remove("hidden")
    this.phoneFieldTarget.classList.add("hidden")

    this.emailBtnTarget.classList.remove("bg-support-light-300", "text-support-dark-700")
    this.emailBtnTarget.classList.add("bg-core-purple-500", "text-white")
    
    this.phoneBtnTarget.classList.remove("bg-core-purple-500", "text-white")
    this.phoneBtnTarget.classList.add("bg-support-light-300", "text-support-dark-700")

    const phoneInput = this.phoneFieldTarget.querySelector("input")
    if (phoneInput) {
      phoneInput.value = ""
    }
    
    const emailInput = this.emailFieldTarget.querySelector("input")
    if (emailInput) {
      emailInput.focus()
    }
  }

  showPhone() {
    this.phoneFieldTarget.classList.remove("hidden")
    this.emailFieldTarget.classList.add("hidden")

    this.phoneBtnTarget.classList.remove("bg-support-light-300", "text-support-dark-700")
    this.phoneBtnTarget.classList.add("bg-core-purple-500", "text-white")
    
    this.emailBtnTarget.classList.remove("bg-core-purple-500", "text-white")
    this.emailBtnTarget.classList.add("bg-support-light-300", "text-support-dark-700")

    const emailInput = this.emailFieldTarget.querySelector("input")
    if (emailInput) {
      emailInput.value = ""
    }
    
    const phoneInput = this.phoneFieldTarget.querySelector("input")
    if (phoneInput) {
      phoneInput.focus()
    }
  }
}
